import { httpClient, postProcessUpsert } from "@genai/http-client";
import { CollectionId, StoredFile } from "../model";

export function uploadFile(
  collectionId: CollectionId,
  file: File,
  chunkingStrategy: string,
) {
  const payload = {
    name: file.name,
    file_type: file.type,
    chunking_strategy: chunkingStrategy,
    tags: {},
  };
  const formData = new FormData();
  formData.append("file_bytes", file);
  formData.append("collection_uuid", collectionId);
  formData.append("payload", JSON.stringify(payload));

  return httpClient(`/collections/${collectionId}/files`, {
    method: "POST",
    body: formData,
  }).then(postProcessUpsert<StoredFile>);
}
